import * as React from "react";
function SvgSun(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 11a1 1 0 010 2h-4v-2h4zm-2.293-6.707a1 1 0 010 1.414l-1.414 1.414-1.414 1.415-1.415-1.415 1.415-1.414 1.414-1.414a1 1 0 011.414 0zM12 14a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 100-8 4 4 0 000 8zm0-15a1 1 0 011 1v4h-2V2a1 1 0 011-1zm1 21v-4h-2v4a1 1 0 002 0zm6.707-2.293a1 1 0 000-1.414l-2.829-2.829-1.414 1.415 2.829 2.828a1 1 0 001.414 0zm-15.243-14a1 1 0 111.414-1.414L8.707 7.12 7.293 8.536 4.464 5.707zM1.171 12a1 1 0 011-1h4v2h-4a1 1 0 01-1-1zm3.293 6.293a1 1 0 101.414 1.414l2.829-2.828-1.414-1.415-2.829 2.829z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgSun);
export default ForwardRef;
